import axios, {AxiosInstance, AxiosRequestConfig} from "axios";
import {App} from "vue";

declare module '@vue/runtime-core' {
	export interface ComponentCustomProperties {
		$api: AxiosInstance
	}
}

export const ApiPlugin = {
	install(app: App, options?: AxiosRequestConfig) {
		Object.defineProperty(app.config.globalProperties, "$api", {
			get() {
				return axios.create(options || {});
			},
		});
	}
}
